import type { EventBusContextValue } from "./event-bus.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "EventBusContext",
  providerName: "EventBusProvider",
};

export const EventBusContext = createContext<EventBusContextValue | null>(null);

export const useEventBus = () => {
  const contextValue = useContext(EventBusContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
